import React from 'react'
import { useDropzone } from 'react-dropzone'
import Label from './Label'
import useInput from '../../hooks/useInput'

export default function FileInput ({
  label,
  name,
  restUrl,
  required = false,
  maxFiles = 1,
  accept = {
    'image/jpeg': [],
    'image/png': []
  },
  placeholder = 'Slip fil her eller',
  text = 'Her kan du vedhæfte en billedfil, hvis du har et billede, du gerne vil have skal bruges til annoncen. OBS på filkrav: Filformat: jpg eller png.'
}) {
  const { getValue, setValue } = useInput()

  const upload = function (files) {
    if (typeof files === 'undefined' || files.length < maxFiles) {
      return
    }

    let data = new FormData()
    data.append('file', files[0])
    fetch(restUrl + getValue('token'), {
      method: 'POST',
      body: data
    })
      .then(response => response.json())
      .then(response => {
        if (response?.success === true) {
          setValue('image', response.data.imageUrl)
        }
      })
      .catch(() => {
        setValue('image', null)
      })
      .finally(() => console.log('Done with image'))
  }

  const {
    fileRejections,
    getRootProps,
    getInputProps
  } = useDropzone({
    maxFiles: maxFiles,
    accept: accept,
    maxSize: 10000000,
    onDrop: upload
  })

  const rejectedFiles = function () {
    if (fileRejections.length < 1) {
      return null
    }
    return (
      <aside>
        Afviste Filer:
        <ul>
          {fileRejections.map(({ file, errors }) => (
            <li key={file.path}>
              {file.path} - {file.size} bytes
              <ul>
                {errors.map(e => (
                  <li key={e.code}>{e.message}</li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </aside>
    )
  }

  const clear = function () {
    setValue(name, null)
  }

  if (getValue(name) !== null) {
    return (
      <div className="input-wrap">
        <Label required={required}>{label}</Label>
        <figure
          className={'image-preview-wrapper'}
          style={{ backgroundImage: 'url(' + getValue(name) + ')' }}
        >
          <button className={'remove'} title={'Fjern billede'} onClick={clear}>x</button>
        </figure>
      </div>
    )
  }

  return (
    <section className="input-wrap">
      <Label required={required}>{label}</Label>
      <div {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} multiple={maxFiles > 1} />
        <p>{placeholder}</p>
        <button className={'button outline-dark'}>{maxFiles > 1 ? 'Vælg filer' : 'Vælg fil'}</button>
      </div>
      <p></p>
      <aside>
        {rejectedFiles()}
      </aside>
      <p dangerouslySetInnerHTML={{ __html: text }} />
    </section>
  )
}
